import { render, staticRenderFns } from "./ContractDetail.vue?vue&type=template&id=8a82c038&scoped=true"
import script from "./ContractDetail.vue?vue&type=script&lang=js"
export * from "./ContractDetail.vue?vue&type=script&lang=js"
import style0 from "./ContractDetail.vue?vue&type=style&index=0&id=8a82c038&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a82c038",
  null
  
)

export default component.exports